import Receipt from './Receipt';
export default Receipt;
